import React from "react";
import {useNavigate} from "react-router-dom";
import {Grid, Card, Space, Row} from "antd";
import {CheckOutlined} from "@ant-design/icons";
import GraphicChip from "../../Components/GraphicChip";
import PortfolioPageCard from "../../Pages/Portfolio/PortfolioPageCard";

const DashboardCards = ({portfolios})=>{
    const navigate = useNavigate();
    const signalTextColor = portfolios.length > 0 ? '#fff' : '#fff';
    const SignalCard = <GraphicChip
        imgUrl={'https://storage.googleapis.com/finiat-web-static-resources/NEWEST-7-9-2024/calendar-closeup.jpeg'}
        title={'Trading Signals'}
        tag={portfolios.length > 0 ? `${portfolios.length} Signals` : <CheckOutlined color={'white'}/>}
        onClick={()=>{
            navigate('/signals')
        }}
        backgroundSize={'100% 100%'}
        textColor={signalTextColor}
        tagWeight={portfolios.length>0?'700':'300'}
        showIcon={true}
    />

    return (

          <Row gutter={[0, 0]} wrap={true} justify={'start'} className={'px-4'}>
            {/*We set xs=12 and lg=24 since on xs and md it will be fullscreen */}
              {SignalCard}
              <PortfolioPageCard />
          </Row>
    )
}


export default DashboardCards;